import {useQuery} from '@tanstack/react-query';
import Device from 'src/core/data/api/Device';
import DeviceService from 'src/services/device-service';

export const deviceKeys = {
  all: ['device'] as const,
  details: () => [...deviceKeys.all, 'detail'] as const,
  detail: (id: number) => [...deviceKeys.details(), id] as const,
};

export const useDevices = () => {
  const deviceService = new DeviceService();

  return useQuery<unknown, unknown, Device[]>({
    queryKey: deviceKeys.all,
    queryFn: () => deviceService.list(),
    initialData: [],
  });
};

export const useDeviceDetails = (id: number, options?: {enabled?: boolean; staleTime?: number}) => {
  const deviceService = new DeviceService();

  const {data, isLoading, isRefetching, isFetching, refetch} = useQuery<unknown, unknown, Device>({
    queryKey: deviceKeys.detail(id),
    queryFn: () => deviceService.getById(id),
    enabled: options?.enabled,
    staleTime: options?.staleTime,
  });

  return {
    data,
    isFetching,
    isLoading,
    isRefetching,
    refetch,
  };
};
